import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "indicator", "completed", "total", "autoSaveStatus", "saveText", "commentCount"]
  
  connect() {
    this.updateProgress()
  }
  
  updateProgress() {
    const totalFields = this.fieldTargets.length
    const completedFields = this.fieldTargets.filter(field => {
      const value = field.value.trim()
      return value !== "" && value !== "0" && value !== "0.00"
    }).length
    
    // Update progress indicator
    if (this.hasCompletedTarget) {
      this.completedTarget.textContent = completedFields
    }
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = totalFields
    }
    
    // Update indicator badge color based on completion
    if (this.hasIndicatorTarget) {
      const percentage = (completedFields / totalFields) * 100
      this.indicatorTarget.className = this.getBadgeClass(percentage)
    }
    
    // Update comment character count
    const commentField = this.fieldTargets.find(field => field.name && field.name.includes('comments'))
    if (commentField && this.hasCommentCountTarget) {
      this.commentCountTarget.textContent = commentField.value.length
    }
  }
  
  getBadgeClass(percentage) {
    if (percentage === 0) return "badge theme-badge-secondary"
    if (percentage < 50) return "badge theme-badge-warning"
    if (percentage < 100) return "badge theme-badge-info"
    return "badge theme-badge-success"
  }
  
  disconnect() {
    // Clean up any resources if needed
  }
}
